/***
 * Contient la liste des différent type de controles
 * et leurs valeur correspondante
 * */
export enum ControlTypes {
    CTRL_NONE = -1,
    CTRL_FRAME = 0,
    CTRL_SSDBGRID = 1,
    CTRL_SSTAB = 2,
    CTRL_COMMAND = 3,
    CTRL_TREEVIEW = 4,
    // 5 a ete supprime
    CTRL_ISICOMBOCRITERE = 6,
    CTRL_ISITEXTCONNEXE = 7,
    // 9 a ete supprime
    CTRL_ISITEXTDATE = 10,
    CTRL_ISITEXTID = 11,
    CTRL_ISITEXTNUM = 12,
    CTRL_ISICHECKBOX = 13,
    CTRL_ISIMEMO = 14,
    CTRL_ISITEXTBOX = 16,
    CTRL_ISIBUTTON = 17,
    CTRL_ISIHYPERLINK = 18,
    CTRL_IMAGE = 19,
    CTRL_IMAGEBUTTON = 20,
    CTRL_LABEL = 21,
    CTRL_ISILINKBUTTON = 23,
    CTRL_ISIPANEL = 24,
    CTRL_ISICOMBOYESNO = 25,
    CTRL_ULTRAWEBGRID = 26,
    CTRL_HIDDEN = 27,
    CTRL_ISITEXTBOXFILE = 28,
    // 29 à été supprimé
    CTRL_ISIRICHTEXT = 30,
    // 31 a ete supprime
    CTRL_ISICOMBOCALENDAR = 32,
    CTRL_ISISCHEDULEPROPERTIESCTRL = 33,
    CTRL_ISISCHEDULE = 34,
    CTRL_ISICALENDARVIEW = 35,
    CTRL_ISIWORKFLOW = 36,
    CTRL_ISIOVERVIEW = 37,
    CTRL_ISIATTPREVIEW = 38,
    CTRL_ISICOLORPICKER = 39,
    CTRL_ISIWORKFLOWIMPACT = 40,
    CTRL_ISIEXTSEARCH = 41,
    CTRL_ISITIMEPROGRESS = 42,
    CTRL_ISIICONCHOOSER = 46,
    CTRL_ISIMENUNAVIGATION = 47,
    CTRL_ISIWEBTAB = 48,
    CTRL_ISIWEBTABITEM = 49,
    CTRL_ISIDIAGRAMSHAPE = 50,
    CTRL_ISIWORKFLOWV2 = 51,
    CTRL_ISIDYNAMIC = 52,
    CTRL_ISIHTMLCONTROL = 53,
    CTRL_ISISCANCONTROL = 54,
    CTRL_ISIDATALISTCTRL = 55,
    CTRL_ISIBSCONTAINER = 56,
    CTRL_ISIBSROW = 57,
    CTRL_ISIBSCOLUMN = 58,
    CTRL_ISIGENERIC = 59,
    COLDATATYPE_LONG = 0,
    COLDATATYPE_NC = 1,
    CTRL_ILLUSTRATION = 60,
    CTRL_ROISITEXTBOX = 61,
    CTRL_ROISITEXTNUM = 62,
    CTRL_ROISITEXTDATE = 63,
    CTRL_ROISICOMBOYESNO = 64,
    CTRL_ROISIHTMLCONTROL = 65,
    CTRL_ROISITEXTCONNEXE = 66,
    CTRL_ROISIMEMO = 67
}